var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 54,
    viewBox: "0 0 37 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#probadgestudiocard)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1 0L2.00148 47V0H1Z",
    fill: "#18252D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0H36V46C36 49.3137 33.3137 52 30 52H8C4.68629 52 2 49.3137 2 46V0Z",
    fill: "url(#probadgestudiocard1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6866 9.8604C18.1042 8.59862 19.9225 8.59862 20.3401 9.8604L21.5115 13.3996C21.6983 13.9639 22.2339 14.346 22.8383 14.346H26.6289C27.9804 14.346 28.5423 16.0437 27.4489 16.8235L24.3822 19.0109C23.8933 19.3597 23.6887 19.9778 23.8754 20.5421L25.0468 24.0814C25.4644 25.3431 23.9934 26.3924 22.9 25.6126L19.8333 23.4252C19.3444 23.0764 18.6823 23.0764 18.1933 23.4252L15.1266 25.6126C14.0333 26.3924 12.5622 25.3431 12.9799 24.0814L14.1512 20.5421C14.338 19.9778 14.1334 19.3597 13.6445 19.0109L10.5777 16.8235C9.48441 16.0437 10.0463 14.346 11.3977 14.346H15.1884C15.7928 14.346 16.3284 13.9639 16.5152 13.3996L17.6866 9.8604Z",
    fill: "#18252D",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6866 9.11821C18.1042 7.85643 19.9225 7.85643 20.3401 9.11821L21.5115 12.6575C21.6983 13.2217 22.2339 13.6038 22.8383 13.6038H26.6289C27.9804 13.6038 28.5423 15.3015 27.4489 16.0813L24.3822 18.2687C23.8933 18.6175 23.6887 19.2356 23.8754 19.7999L25.0468 23.3392C25.4644 24.601 23.9934 25.6502 22.9 24.8704L19.8333 22.683C19.3444 22.3343 18.6823 22.3343 18.1933 22.683L15.1266 24.8704C14.0333 25.6502 12.5622 24.601 12.9799 23.3392L14.1512 19.7999C14.338 19.2356 14.1334 18.6175 13.6445 18.2687L10.5777 16.0813C9.48441 15.3015 10.0463 13.6038 11.3977 13.6038H15.1884C15.7928 13.6038 16.3284 13.2217 16.5152 12.6575L17.6866 9.11821Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 36.5C4 34.0147 6.06638 32 8.61538 32H29.3846C31.9336 32 34 34.0147 34 36.5V45.5C34 47.9853 31.9336 50 29.3846 50H8.61538C6.06638 50 4 47.9853 4 45.5V36.5Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9899 36.4876C12.4968 36.4876 12.9413 36.5957 13.3236 36.8117C13.7141 37.0194 14.0132 37.3144 14.221 37.6966C14.437 38.0789 14.545 38.5193 14.545 39.0178C14.545 39.5164 14.437 39.9526 14.221 40.3265C14.0049 40.7005 13.6975 40.9913 13.2986 41.199C12.9081 41.4068 12.4552 41.5106 11.9401 41.5106H9.75886C9.71732 41.5106 9.69654 41.5314 9.69654 41.5729V45.0379C9.69654 45.0961 9.67992 45.1418 9.64669 45.175C9.61345 45.2083 9.56775 45.2249 9.50958 45.2249H8.68696C8.62879 45.2249 8.58309 45.2083 8.54986 45.175C8.51662 45.1418 8.5 45.0961 8.5 45.0379V36.6746C8.5 36.6164 8.51662 36.5707 8.54986 36.5375C8.58309 36.5043 8.62879 36.4876 8.68696 36.4876H11.9899ZM11.8279 40.5384C12.2849 40.5384 12.6505 40.4013 12.9247 40.1271C13.2072 39.8529 13.3485 39.4915 13.3485 39.0428C13.3485 38.5857 13.2072 38.2201 12.9247 37.9459C12.6505 37.6634 12.2849 37.5221 11.8279 37.5221H9.75886C9.71732 37.5221 9.69654 37.5429 9.69654 37.5845V40.4761C9.69654 40.5177 9.71732 40.5384 9.75886 40.5384H11.8279Z",
    fill: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9661 45.2249C20.8664 45.2249 20.7958 45.1792 20.7543 45.0878L19.0342 41.3984C19.0176 41.3652 18.9927 41.3486 18.9594 41.3486H17.202C17.1605 41.3486 17.1397 41.3694 17.1397 41.4109V45.0379C17.1397 45.0961 17.1231 45.1418 17.0898 45.175C17.0566 45.2083 17.0109 45.2249 16.9527 45.2249H16.1301C16.072 45.2249 16.0263 45.2083 15.993 45.175C15.9598 45.1418 15.9432 45.0961 15.9432 45.0379V36.6746C15.9432 36.6164 15.9598 36.5707 15.993 36.5375C16.0263 36.5043 16.072 36.4876 16.1301 36.4876H19.4206C19.9192 36.4876 20.3554 36.5915 20.7293 36.7992C21.1116 37.007 21.4065 37.2978 21.6143 37.6717C21.822 38.0456 21.9259 38.4777 21.9259 38.968C21.9259 39.5413 21.7721 40.0316 21.4647 40.4387C21.1573 40.8376 20.7418 41.1076 20.2183 41.2489C20.1851 41.2655 20.1726 41.2904 20.1809 41.3237L21.9508 45.0005L21.9757 45.1002C21.9757 45.1833 21.9217 45.2249 21.8137 45.2249H20.9661ZM17.202 37.5221C17.1605 37.5221 17.1397 37.5429 17.1397 37.5845V40.3515C17.1397 40.393 17.1605 40.4138 17.202 40.4138H19.271C19.7031 40.4138 20.0521 40.2808 20.318 40.0149C20.5922 39.749 20.7293 39.4042 20.7293 38.9804C20.7293 38.54 20.5964 38.1869 20.3305 37.921C20.0646 37.6551 19.7114 37.5221 19.271 37.5221H17.202Z",
    fill: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4089 45.3371C25.8024 45.3371 25.2664 45.2124 24.8011 44.9631C24.3358 44.7139 23.9743 44.3649 23.7167 43.9162C23.4591 43.4592 23.3303 42.9357 23.3303 42.3457V39.3793C23.3303 38.7893 23.4591 38.27 23.7167 37.8213C23.9743 37.3726 24.3358 37.0236 24.8011 36.7743C25.2664 36.525 25.8024 36.4004 26.4089 36.4004C27.0238 36.4004 27.5639 36.525 28.0292 36.7743C28.4946 37.0236 28.856 37.3726 29.1136 37.8213C29.3712 38.27 29.5 38.7893 29.5 39.3793V42.3457C29.5 42.9357 29.3712 43.4592 29.1136 43.9162C28.856 44.3649 28.4946 44.7139 28.0292 44.9631C27.5639 45.2124 27.0238 45.3371 26.4089 45.3371ZM26.4089 44.3026C26.974 44.3026 27.431 44.1281 27.78 43.7791C28.129 43.4301 28.3035 42.9689 28.3035 42.3956V39.3668C28.3035 38.7852 28.129 38.3198 27.78 37.9709C27.431 37.6136 26.974 37.4349 26.4089 37.4349C25.8439 37.4349 25.3869 37.6136 25.0379 37.9709C24.6972 38.3198 24.5269 38.7852 24.5269 39.3668V42.3956C24.5269 42.9689 24.6972 43.4301 25.0379 43.7791C25.3869 44.1281 25.8439 44.3026 26.4089 44.3026Z",
    fill: "#F7FCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "probadgestudiocard",
    x: 0,
    y: 0,
    width: 37,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "probadgestudiocard1",
    x1: 25.5,
    y1: -3.56826e-8,
    x2: 5.29025,
    y2: 48.4069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.2623,
    y1: 8.17188,
    x2: 18.146,
    y2: 25.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProBadge);
export default __webpack_public_path__ + "static/media/pro-badge.ed1fc34e78bb72340beda8fc3f51358e.svg";
export { ForwardRef as ReactComponent };